<template>
  <div class="WordCloudSummary">
    <block-title title="Concept analysis" class="desktop:mb-8" />
    <WordCloud
      ref="wordcloud"
      summary
      :cloud-data="data.cloud"
      @reload="onReload"
    />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {WordcloudTypes} from '@/lib/definitions'
import BlockTitle from '@/components/landscape/info/BlockTitle'
import WordCloud from '@/components/landscape/info/wordcloud/WordCloud'

export default {
  name: 'WordCloudSummary',
  components: {BlockTitle, WordCloud},
  props: {},
  data() {
    return {
      data: {}
    }
  },
  computed: {
    ...mapGetters(['hasWatsonKeywords'])
  },
  methods: {
    onReload() {
      const types = [WordcloudTypes.TAGS]
      if (this.hasWatsonKeywords) {
        types.push('KEYWORDS')
      }
      this.$store.dispatch('loadAnal', {types}).then(data => {
        this.data = data
      })
    }
  }
}
</script>

<style scoped></style>
